<template>
    <div class="elAreaTree">
         <!-- 新的Element单选区域树形控件 -->
        <div style="margin-bottom: 5px;">
            <el-input size="medium" placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
        </div>
         	<el-scrollbar style="height:calc(100% - 55px);width: 100%;">
                <el-tree :data="data"  :default-expanded-keys="defaultExpanded" 
                    :current-node-key='defaultDevice'
                    :expand-on-click-node="true" 
                    node-key="id" :props="defaultProps" :highlight-current='true' :filter-node-method="filterNode" ref="tree" @node-click="nodeClick">
                        <span class="custom-tree-node" slot-scope="{node}">
                        <img src="../../../../public/static/image/elTree/1.9.png"/>
                        <span style="padding: 5px;">{{node.label }}</span>
                        </span>
			</el-tree>
		</el-scrollbar>
    </div>
</template>

<script>
export default {
        props: {
			dataList: {
				type: Array,
				required: true,
				default: []
			},
		},
    data() {
        return {
                filterText: "",
                data: [],
				defaultProps: {
					children: 'energyAreaVos',
					label: 'label'
				},
                defaultExpanded:[],
				defaultDevice:"",
                nowArea:[]
        };
    },

    mounted() {
        if(!isempty(this.dataList)) {
				this.data = this.dataList
			}
            this.nowArea = this.$store.cacheStore.state.setBuilding
            this.defaultExpanded = [this.nowArea.id]
            this.defaultDevice = this.nowArea.id
           this.$nextTick(()=>{
					//默认选中
					this.$refs['tree'].setCurrentKey(this.defaultDevice);
				})
    },
    watch:{
          filterText(val) {
				this.$refs.tree.filter(val);
			},
             dataList(val){
              this.data = val
           },
           storeNowArea(v){
              this.nowArea = v
              this.defaultExpanded = [v.id]
            this.defaultDevice = v.id
            this.$nextTick(()=>{
					//默认选中
					this.$refs['tree'].setCurrentKey(this.defaultDevice);
				})
           }
    },
    computed:{
       storeNowArea(){
                return this.$store.cacheStore.state.setBuilding
            }
    },

    methods: {
      filterNode(value, data) {
				if(!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			nodeClick(value, nodeData) {
				var d = value
				d.name = d.label
				this.$store.cacheStore.commit("setBuilding", d)
			},
    },
};
</script>

<style lang="scss" scoped>
  .elAreaTree {
    width: 100%;
    height: 100%;
    .custom-tree-node {
        display: flex;
        align-items: center;
        img {
            margin-right: 1px;
        }
    }
    
  }
</style>